import imageOne from '../../assets/images/jobs/portfolio.svg';
import imageTwo from '../../assets/images/jobs/portfolio-2.svg';
import responsiveImageSrc from '../../assets/images/jobs/responsive.svg';
export var sampleData = {
    tabList: [
        {
            mockListFeaturesArray: [
                {
                    title: "Trading and Reporting",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 1,
                    content: "Clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Financial Planning",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Tax Overlay Services",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 3,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Annuity Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 4,
                    content: "Annuity Solutions to be active participants in Annuity Solutions process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Credit Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 5,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Data Aggregation",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 6,
                    content: "Empower your Data Aggregation to be Data Aggregation in the planning of Data Aggregation process with Data Aggregation strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Analytics",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 7,
                    content: "Empower your Analytics to be active Analytics in the planning Analytics with goal-Analytics strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Insights",
                    href: "https://www.envestnet.com",
                    order: 8,
                    content: "Insights your clients to be Insights participants in the Insights process Insights goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
            ],
            defaultMainTitleText: {
                value: "Explore the interconnected solutions that bring it all together",
            },
        },
        {
            mockListFeaturesArray: [
                {
                    title: "Trading and Reporting",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 1,
                    content: "Clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Financial Planning",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Tax Overlay Services",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 3,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Annuity Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 4,
                    content: "Annuity Solutions to be active participants in Annuity Solutions process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Credit Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 5,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Data Aggregation",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 6,
                    content: "Empower your Data Aggregation to be Data Aggregation in the planning of Data Aggregation process with Data Aggregation strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Analytics",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 7,
                    content: "Empower your Analytics to be active Analytics in the planning Analytics with goal-Analytics strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Insights",
                    href: "https://www.envestnet.com",
                    order: 8,
                    content: "Insights your clients to be Insights participants in the Insights process Insights goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
            ],
            defaultMainTitleText: {
                value: "Explore the interconnected solutions that bring it all together",
            },
        },
        {
            mockListFeaturesArray: [
                {
                    title: "Trading and Reporting",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 1,
                    content: "Clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Financial Planning",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Tax Overlay Services",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 3,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Annuity Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 4,
                    content: "Annuity Solutions to be active participants in Annuity Solutions process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Credit Solutions",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 5,
                    content: "Empower your clients to be active participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Data Aggregation",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 6,
                    content: "Empower your Data Aggregation to be Data Aggregation in the planning of Data Aggregation process with Data Aggregation strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Analytics",
                    subtext: 'some text to display when hover',
                    href: "https://www.envestnet.com",
                    order: 7,
                    content: "Empower your Analytics to be active Analytics in the planning Analytics with goal-Analytics strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageTwo,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
                {
                    title: "Insights",
                    href: "https://www.envestnet.com",
                    order: 8,
                    content: "Insights your clients to be Insights participants in the Insights process Insights goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    image: {
                        src: imageOne,
                        title: "",
                        alt: "",
                    },
                    responsiveImage: {
                        src: responsiveImageSrc,
                        title: "",
                        alt: "",
                    },
                },
            ],
            defaultMainTitleText: {
                value: "Explore the interconnected solutions that bring it all together",
            },
        },
    ],
};
